"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'knowledge.form.title.edit': 'Editar conocimiento',
    'knowledge.form.title.add': 'Agregar conocimiento',
    'knowledge.form.back': 'Atrás',
    'knowledge.form.title.label': 'Título',
    'knowledge.form.title.placeholder': 'Introducir título del conocimiento',
    'knowledge.form.description.label': 'Descripción',
    'knowledge.form.description.placeholder': 'Introducir descripción del conocimiento',
    'knowledge.form.description.help': 'Proporcione una breve descripción para ayudar a identificar este conocimiento',
    'knowledge.form.content.label': 'Contenido',
    'knowledge.form.content.placeholder': 'Introducir contenido del conocimiento',
    'knowledge.form.file.label': 'Archivo',
    'knowledge.form.file.placeholder': 'Seleccionar archivo',
    'knowledge.form.project.label': 'Proyecto',
    'knowledge.form.project.placeholder': 'Seleccionar proyecto',
    'knowledge.form.tags.label': 'Etiquetas',
    'knowledge.form.tags.placeholder': 'Introducir etiquetas separadas por comas',
    'knowledge.form.tags.help': 'Usar Enter para agregar etiquetas',
    'knowledge.form.contentType.label': 'Tipo de contenido',
    'knowledge.form.contentType.help': 'Selecciona el tipo de contenido que deseas agregar',
    'knowledge.form.contentType.text': 'Texto',
    'knowledge.form.contentType.file': 'Archivo',
    'knowledge.form.contentType.link': 'Enlace',
    'knowledge.form.contentType.googleDrive': 'Google Drive',
    'knowledge.form.contentType.google-drive': 'Google Drive',
    'knowledge.form.link.label': 'URL del enlace',
    'knowledge.form.link.placeholder': 'Introducir la URL del enlace',
    'knowledge.form.googleDrive.label': 'URL de Google Drive',
    'knowledge.form.googleDrive.placeholder': 'Introducir URL de compartir de Google Drive',
    'knowledge.form.googleDrive.selectFile': 'Seleccionar de Google Drive',
    'knowledge.form.googleDrive.notAuthenticated': 'Google Drive no conectado. Por favor conecte su cuenta en configuración.',
    'knowledge.form.googleDrive.notConnected': 'Google Drive no conectado',
    'knowledge.form.googleDrive.connect': 'Conectar en Configuración',
    'knowledge.form.googleDrive.configureSettings': 'Configurar en Ajustes',
    'knowledge.form.googleDrive.statusError': 'Error al verificar el estado de Google Drive',
    'knowledge.form.googleDrive.fileSelected': 'Archivo de Google Drive seleccionado exitosamente',
    'knowledge.form.timed.label': 'Habilitar disponibilidad basada en tiempo',
    'knowledge.form.timed.help': 'Restringir cuándo este conocimiento está disponible para avatares',
    'knowledge.form.startTime.label': 'Hora de inicio',
    'knowledge.form.startTime.placeholder': 'Seleccionar fecha de inicio',
    'knowledge.form.endTime.label': 'Hora de fin',
    'knowledge.form.endTime.placeholder': 'Seleccionar fecha de fin',
    'knowledge.form.googleDrive.fileCleared': 'Archivo de Google Drive eliminado',
    'knowledge.form.active.label': 'Activo',
    'knowledge.form.active.help': 'Activar este conocimiento para su uso',
    'knowledge.form.rag_status.label': 'Estado RAG',
    'knowledge.form.content_type.label': 'Tipo de Contenido',
    'knowledge.form.submit.update': 'Actualizar conocimiento',
    'knowledge.form.submit.create': 'Crear conocimiento',
    'knowledge.form.reset.debug': 'Restableciendo formulario al estado inicial',
    'knowledge.form.reset.complete': 'Restablecimiento de partes del formulario completo',
    'knowledge.form.reset.forNext': 'Restableciendo formulario para la siguiente entrada',
    'knowledge.form.projects.loadError': 'Error al cargar proyectos:',
    'knowledge.form.load.error': 'Error al cargar conocimiento',
    'knowledge.form.submit.duplicateWarning': 'Envío de formulario ya en progreso, ignorando envío duplicado',
    'knowledge.form.submit.starting': 'Iniciando envío de formulario con datos:',
    'knowledge.form.submit.updating': 'Actualizando conocimiento con ID:',
    'knowledge.form.submit.creating': 'Creando nueva entrada de conocimiento',
    'knowledge.form.submit.updateError': 'Error al actualizar conocimiento',
    'knowledge.form.submit.createError': 'Error al crear conocimiento',
    'knowledge.form.submit.updateSuccess': 'Conocimiento actualizado exitosamente',
    'knowledge.form.submit.createSuccess': 'Conocimiento creado exitosamente',
    'knowledge.form.submit.success': 'Conocimiento creado exitosamente:',
    'knowledge.form.submit.error': 'Error al guardar conocimiento:',
    'knowledge.form.validation.fileRequired': 'El archivo es requerido',
    'knowledge.form.validation.timedDatesRequired': 'Se requieren tanto la hora de inicio como la de fin cuando está habilitado el tiempo',
    'knowledge.form.fileProcessing.completed': 'Procesamiento de archivo completado exitosamente',
    'knowledge.form.fileProcessing.failed': 'El procesamiento del archivo falló',
    'knowledge.form.ragOverride.title': 'Anulación de Configuración de Indexación',
    'knowledge.form.ragOverride.description': 'Opcionalmente anule la configuración de indexación RAG predeterminada para esta entrada de conocimiento.',
};
